import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="bg-navy text-center text-ivory" aria-label="Offerta a tempo limitato" data-id="element-221" data-mp="2sk46nkhn1yb1">
      <div className="h-1 w-full bg-gold" aria-hidden="true" data-id="element-222" data-mp="36biovp3q1vh1" />
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-223" data-mp="31ipikwsluf2u">
        <p className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-[.16em] text-gold" data-id="element-224" data-mp="31h4ot9e47061">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-225" data-mp="3g9yfzs2r14qj" /> Il prezzo di lancio termina tra
        </p>
        <Countdown className="mt-5" data-id="element-226" data-mp="3p8tjuxibm2qo" />
        <p className="mt-7 font-bold text-ivory/80" data-id="element-227" data-mp="3p7sbj0sovucn">Dopo, il prezzo aumenta e non tornerà più così basso.</p>
      </div>
      <div className="h-1 w-full bg-gold" aria-hidden="true" data-id="element-228" data-mp="3l7q6qirnqkt5" />
    </section>;
}